import { render } from "./SearchSuggestions.vue?vue&type=template&id=52aa338c&scoped=true"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js"

import "./SearchSuggestions.vue?vue&type=style&index=0&id=52aa338c&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52aa338c"]])

export default __exports__